var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelease(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 31,
    fill: "url(#pattern0_3576_3629)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3576_3629",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3576_3629",
    transform: "matrix(0.0104377 0 0 0.0111111 -0.0010101 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3576_3629",
    width: 96,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABaCAYAAABHeVPzAAADYElEQVR4AeydUW4zIQyE0x5i73++XKIVD1SWMYthDE6T+SW0rNce4/l+3iL1+8F/qQ4QQKr9jwcBEECyA8nteQMIINmB5Pa8AQSQ7EBye94AAeC6rp8dS7RotgTQWHI28JkAznp8240AOvY8n88vZHVkmzABNJacDRDAWb+bbgTQWHI2QABn/W66EUBjydkAAZz1u+lGAI0lZwMEcNbvphsBNJacDRwEcHaw/9KNAJJJEQABJDuQ3J43gACSHUhuzxtAAMkOJLfnDSCAZAeS2/MGbAYwkieAkUObvxPAZoNH8gQwcmjz948AUH5uuNnHZflQAGXQspZPIwqLTlkiBG0jtaCDqOJQAFUbHRatr+coz0itohe9wgDsGjRSN1IrCkQIAGswK+Y5tFVnxVa1PHUnc0IARB141Wirf0+rF7c0TsRgAHcD3X0bDVd+mSxzEC2p82p7GIAcqJhWlox5jbPytJbUvdtf1/Ujv2sdq5fMP7mHAMhB5JByvzJMr1726+nqnKpVn7VO59X46ecygJkBRrl33xHjdK1+P2221W8ZgBSzBrNisqbutflWnRWr9fKpteQ3az+bb2mgsSUAKwf31CBGa/2eVi+OGrlaPw3AO2g5kB5W1+r3UtNbI61enRWXWjNnsLTQ2DQA2VAOIuNy78kp+d68kquXNnFWS9dr/Z3vUwAiDlo16nNmOG2spaFzevrevF59VHwKgGw6M4DO1cbp77KP3utcraXz796lFqJz12P0zQ0APaAcVh6qF5c53n2klrcnmucCoM3PHtTqb8U85qzWebQ9OS4AUqh/YJll73Wtfrer3js6BKD/97+KHRKe3K+cD61f6VlrhgBqYnlGHLRq1GfRXV0RGrV3pFbV9DynAHgEPTmRw0ZrFb2yPHNE5KQAiDj4u2gQQDJJAiCAZAeS2/MGEECyA8nteQNAAGg5AaAOgvUEABqIlhMA6iBYTwCggWg5AaAOgvUEABqIlhMA6iBYTwCggWg5AaAOgvUEABqIlv9PAOjUL1RPAMkwCIAAkh1Ibs8bQADJDiS3n7oB5VdyXL6/NeblOgXAK8o8vwME4PdqS+YQQPmZHte+vyk2BLAFO0X/HJgA8FfDTaADBBBo5ooUAay4FlhDAIFmrkgRwIprgTW/AAAA//+SVf1QAAAABklEQVQDAKqNcNNNvOBEAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelease);
export default __webpack_public_path__ + "static/media/release.164506b27678ebb942c2f6f1aaae127a.svg";
export { ForwardRef as ReactComponent };